import {ref, computed} from 'vue'
import {useRouter} from 'vue-router'
import {defineStore} from 'pinia'
import humanDate from 'shared/utils/humanDate'
import {useWorkspaceSubscriptionStore} from 'shared/stores/workspaceSubscription'
import {useRouterHelpers} from 'shared/composables/useRouterHelpers'
import {useStore} from 'shared/stores/store'
import {api} from 'shared/plugins/api'

export const usePaddleStore = defineStore('paddle', () => {
	const store = useStore()
	const router = useRouter()
	const routerHelpers = useRouterHelpers(router)
	const workspaceSubscription = useWorkspaceSubscriptionStore()

	const loadingState = ref('loading')
	const nextPaymentAmount = ref(null)
	const nextPaymentDate = ref(null)
	const cancelUrl = ref(null)
	const updatePaymentUrl = ref(null)
	const quantity = ref(null)
	const pausedAt = ref(null)
	const pausingEffectiveAt = ref(null)

	const mailToSupport = computed(() => {
		return `mailto:assist@paddle.com?subject=Support%20for%20Paddle%20Subscription%20ID%20${workspaceSubscription.subscription.id}`
	})

	async function loadSubscriptionDetails() {
		if (!store.hasUserAdminRole) return
		if (workspaceSubscription.isTrialPlan) return
		if (workspaceSubscription.isFreePlan) return
		loadingState.value = 'loading'
		try {
			const data = await api.get(`/subscriptions/details?workspaceId=` + store.workspace.id)
			nextPaymentAmount.value = data.next_payment?.amount
			nextPaymentDate.value = humanDate(data.next_payment?.date, 'numeric')
			cancelUrl.value = data.cancel_url
			updatePaymentUrl.value = data.update_url
			quantity.value = data.quantity
			pausedAt.value = data.paused_at
			pausingEffectiveAt.value = data.paused_from
			loadingState.value = 'loaded'
		} catch (error) {
			loadingState.value = 'error'
			throw error
		}
	}

	function upgradePlan(planId) {
		routerHelpers.pushQueryParams({subscription: 'upgrade', planId})
	}

	function updatePlan() {
		routerHelpers.pushQueryParams({
			subscription: 'update',
			updateUrl: updatePaymentUrl.value,
		})
	}

	function cancelPlan() {
		routerHelpers.pushQueryParams({subscription: 'cancel', cancelUrl: cancelUrl.value})
	}

	return {
		loadingState,
		nextPaymentAmount,
		nextPaymentDate,
		cancelUrl,
		updatePaymentUrl,
		quantity,
		mailToSupport,
		loadSubscriptionDetails,
		upgradePlan,
		updatePlan,
		cancelPlan,
	}
})
